import { render, staticRenderFns } from "./ContainerModal.vue?vue&type=template&id=28a4a0be"
import script from "./ContainerModal.vue?vue&type=script&lang=js"
export * from "./ContainerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports